import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import PartnerCount from '../Earning/partnerCount';
import React, { useEffect, useState } from 'react';
import { PartnerApi } from '../../../api/partnerApi';
import Loader from '../../../component/common/Loader';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { getLocalStorageItem } from '../../../utils/helper';
import Topbar from '../../PulseSurvey/Topbar';

function PartnerDashboard(props) {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [notificationCounts, setNotificationCounts] = useState(0);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const getUnreadNotificationCount = async () => {
    PartnerApi.getUnreadNotificationCount()
      .then((res) => {
        setNotificationCounts(res?.data?.data);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (window.location.pathname !== '/login' && userData.userType === 5)
      getUnreadNotificationCount();
    else setLoader(false);
  }, [userData.userType]);

  return (
    <div className="relative lg:px-5 lg:mb-[45px]">
      {loader ? <Loader /> : null}
      <div className="col-span-3 relative h-full flex flex-col gap-y-5 hide-scrollbar overflow-y-auto">
        <Topbar title={'Hi ' + userData?.name} />
        <div className="flex flex-col gap-2">
          <h1 className="text-shoorah-newDashboardBlue dark:text-white text-xl lg:text-3xl font-medium ">
            Happy {moment().format('dddd')}, let’s make today count!
          </h1>
          <span className="text-shoorah-newDashboardBlue dark:text-white text-base font-normal">
            Welcome to your Partner Dashboard
          </span>
        </div>

        <PartnerCount />
      </div>
    </div>
  );
}

export default PartnerDashboard;
